import React from 'react';

import { useTranslation } from 'react-i18next';

import {
  StyledHeader, Title, Version, UserInfoContainer,
  TitleVersionContainer, UserName, UserAccessInfo,
} from './styles';

const Header = () => {
  const { t } = useTranslation();

  return (
    <StyledHeader>
      <TitleVersionContainer>
        <Title>{t('header.title')}</Title>
        <Version>{t('header.version')}</Version>
      </TitleVersionContainer>
      <UserInfoContainer>
        <UserName>{t('header.userName')}</UserName>
        <UserAccessInfo>viemar - admin</UserAccessInfo>
      </UserInfoContainer>
    </StyledHeader>
  );
};

export default Header;
